import { EntityStatusDesc } from '../../../models/entity.model'
import { PermissionsScope } from '../../policies/policy.model'
import { MovementReason } from '../models/movement.types'

export const MOVEMENT_FRAGMENT = 'movement'
export const MOVEMENT_SCOPE: PermissionsScope = 'movements'

export const MOVEMENT_REASONS: EntityStatusDesc<MovementReason>[] = [
  {
    code: 'INCREASE',
    name: 'Increase',
  },
  {
    code: 'DECREASE',
    name: 'Decrease',
  },
  {
    code: 'PACKING',
    name: 'Packing action',
  },
  {
    code: 'PICKING',
    name: 'Picking',
  },
  {
    code: 'TRANSFER',
    name: 'Transfer',
  },
  {
    code: 'RECEIVE',
    name: 'Reception',
  },
  {
    code: 'CANCELLATION',
    name: 'Cancelation',
  },
  {
    code: 'REPLENISH',
    name: 'Replenish',
  },
]
